import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para todas las edades?',
  a: 'Sí. El MegaPack cubre de 1 a 12 años con protocolos específicos por edad en cada tomo. El Pack Familiar Completo agrega de 11 a 18 años y los protocolos para adultos.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Apenas confirmás el pago, recibís un mail con el acceso inmediato a todos los PDFs. En menos de 5 minutos tenés todo en tu dispositivo.'
}, {
  q: '¿Qué lo diferencia de los consejos que encuentro en Instagram?',
  a: 'Los consejos sueltos no son un sistema. Este MegaPack tiene protocolos integrados, planes de días específicos, herramientas visuales, guiones exactos y un diagnóstico paso a paso. No es información — es un sistema aplicable esta noche.'
}, {
  q: '¿Qué pasa si mi hijo tiene TDAH o alta sensibilidad?',
  a: 'El Tomo 3 está diseñado específicamente para cerebros acelerados. Incluye diagnóstico de 5 perfiles, protocolo de desactivación sensorial, vaciado cognitivo y plan de 21 días adaptado.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días, devolución del 100%, sin preguntas. Mandás un mail a soporte.zentralpro@gmail.com y listo. Sin formularios, sin esperas, sin drama.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-charcoal" data-id="element-113">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white" data-id="element-116">
            LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-2" data-id="element-117">
          {faqs.map((faq, i) => <div key={i} className="bg-night-light rounded border border-white/10 overflow-hidden shadow-sm" data-id="element-118">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-119">
                <span className="font-bold text-lg text-white pr-8" data-id="element-120">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-121">
                  <ChevronDown className="w-6 h-6 text-gold shrink-0" data-id="element-122" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-123">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-124">
                    <div className="px-6 pb-6 text-gray-300 text-base leading-relaxed border-t border-white/10 pt-4" data-id="element-125">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}